<template>
  <div class="search-content" @click.passive="$emit('click')">
    <a :href="content.link" class="search-content__link"></a>
    <div class="search-content__item">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="search-content__text" v-html="text"></div>
      <div class="search-content__text search-content__text--muted search-content__text--date">{{ content.date }}</div>
      <div v-for="comment in content.comments" :key="comment.comment_id" class="search-content__comment">
        <CommentPreviewIcon class="search-content__icon search-content__icon--comment" />
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div class="search-content__text search-content__text--muted" v-html="comment.text"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AudioPreviewIcon from '~/assets/svg/audio-preview.vue.svg';
import CommentPreviewIcon from '~/assets/svg/comment-preview.vue.svg';
import VideoPreviewIcon from '~/assets/svg/video-preview.vue.svg';
import PostPreviewIcon from '~/assets/svg/post-preview.vue.svg';

const ICONS_SET = Object.freeze({
  VideoContent: VideoPreviewIcon,
  AudioContent: AudioPreviewIcon,
  Any: PostPreviewIcon,
});

export default {
  name: 'SearchContent',
  components: {
    CommentPreviewIcon,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  computed: {
    icon() {
      return ICONS_SET[this.content.content_type] || ICONS_SET.Any;
    },
    text() {
      const [{ 'body.content_title': title = [], 'body.content_body': body = [] } = {}] = this.content.highlight_body;
      const {
        body: { content_title: contentTitle },
      } = this.content;
      const hasContent = (title && title.length) || (body && body.length) || contentTitle;
      if (!hasContent) return null;
      if (title.includes('<em>')) return title;
      if (body.includes('<em>')) return body;
      return title || body || contentTitle;
    },
  },
};
</script>

<style scoped lang="scss">
$font: var(--font-family);
$color: var(--universal-color-gray-3);
$date-color: var(--universal-color-gray-50);
$muted-color: var(--universal-color-gray-50);
$comment-color: var(--universal-color-gray-50);
$highlight-color: var(--universal-color-white);
$icon-color: var(--universal-color-gray-20);

.search-content {
  $this: &;

  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  &__item {
    flex: 1;
  }

  &__text {
    @include multiline-overflow(1);
    @include headline-semibold;

    font-weight: normal;
    color: var(--theme-color-sub-text);
    margin-bottom: 4px;

    ::v-deep em {
      color: var(--theme-color-text);
      font-weight: bold;
      font-style: normal;
    }

    &--date {
      @include caption1;

      color: var(--universal-color-gray-50);
    }

    &--muted {
      color: $muted-color;
    }
  }

  &__icon {
    width: 20px;
    height: 20px;
    flex: 0 0 20px;
    color: $icon-color;

    &--comment {
      width: 16px;
      height: 16px;
      flex: 0 0 16px;
      color: currentColor;
      margin-right: 6px;
    }
  }

  &__date {
    margin-top: 8px;
  }

  &__link {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  &__comment {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: $comment-color;

    #{$this}__text {
      @include subhead;
    }
  }
}
</style>
